import { Component, CUSTOM_ELEMENTS_SCHEMA, EventEmitter, HostListener, Input, Output } from '@angular/core';

import { WebViewInteropService } from 'src/app/service/web-view-interop.service';

@Component({
    selector: 'app-dialog',
    imports: [],
    templateUrl: './dialog.component.html',
    styleUrls: ['./dialog.component.css'],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class DialogComponent {
  @Input() header: string | undefined;
  @Input() content: string | undefined;
  @Input() stackIndex = 0;
  @Input() interactive = false;

  @Output() closed = new EventEmitter<void>();

  constructor(private webViewInterop: WebViewInteropService) {}

  get isFront(): boolean {
    return this.stackIndex === 0;
  }

  get dialogTransform(): string {
    const gaps = [0, 10, 17, 22, 25];
    const offset = gaps[this.stackIndex] ?? gaps[gaps.length - 1] + (this.stackIndex - gaps.length + 1) * 3;
    return `translateY(${offset}px)`;
  }

  get dialogOpacity(): number {
    return Math.max(1 - this.stackIndex * 0.08, 0.7);
  }

  @HostListener('document:keydown.escape')
  onEscape() {
    if (this.isFront) {
      this.closed.emit();
    }
  }

  reload() {
    location.reload();
  }

  closeApp() {
    this.webViewInterop.postMessageToClient("closeAppEvent");
  }
}